import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Client/packs/AgencyAdmin/defaultRequestOptions'

import CampaignQuoteTemplateEditRoutes from './routes'

const CampaignQuoteTemplateEdit = () => {
  const { agencyId, campaignQuoteTemplateId } = useNumericParams()

  useReduxAction(
    'campaignQuoteTemplates',
    'loadCampaignQuoteTemplate',
    {
      entityId: campaignQuoteTemplateId,
      ...defaultRequestOptions.campaignQuoteTemplate,
    },
    [campaignQuoteTemplateId],
    {
      dispatchAction: (action, requestOptions) => action(campaignQuoteTemplateId, requestOptions),
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }) => campaignQuoteTemplateId && !loading,
    },
  )

  return (
    <CampaignQuoteTemplateEditRoutes agencyId={agencyId} />
  )
}

export default CampaignQuoteTemplateEdit
